module.exports = __webpack_public_path__ + "img/ttshop_dpj1.8587dd56.svg";